import { useCallback } from "react";
import { logEventV2, WorkbenchEventName } from "react-migration/lib/util/logEventV2";
import { useDebounceCallback } from "react-migration/lib/util/useDebounceCallback";

export type TrackControlChange = (values: { filterName: string; filterState: any }) => void;

export const useFilterStateTracking = (cardName: string) => {
  const trackControlChange = useCallback<TrackControlChange>(
    ({ filterName, filterState }) => {
      logEventV2({
        name: WorkbenchEventName.WORKBENCH_FILTER_CLICK,
        properties: {
          cardName: cardName,
          filterName,
          filterState,
        },
      });
    },
    [cardName]
  );

  const debouncedTrackControlChange = useDebounceCallback(trackControlChange, 500);

  return { debouncedTrackControlChange, trackControlChange };
};
